import { TYPE } from "vue-toastification";
import { showAlert } from "@/core/popup";
import { resetPassword, resetTotp } from "@/user/services/user.service";
import i18n from "@/core/i18n/i18n";

export function useUserActions() {
  const { t } = i18n.global;

  async function sendResetPassword(emailOrUsername?: string) {
    const email = emailOrUsername?.trim();
    if (!email) {
      showAlert(TYPE.ERROR, t("User.EmailMissing"));
      return false;
    }

    const ok = await resetPassword(email);
    if (ok) {
      showAlert(TYPE.SUCCESS, t("User.PasswordResetLinkSent", { email }));
      return true;
    }

    return false;
  }

  async function resetTotpAndNotify(userId: string) {
    const resp = await resetTotp(userId);
    const success = resp === true || resp?.code === 200;
    if (success) {
      showAlert(TYPE.SUCCESS, t("User.TotpResetSuccess"));
      return true;
    }
    return false;
  }

  return { sendResetPassword, resetTotpAndNotify };
}
